"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialityListWithTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const FlatButton_1 = require("../../atoms/FlatButton/FlatButton");
const SelectableButton_1 = require("../../atoms/SelectableButton/SelectableButton");
const Title_1 = require("../../atoms/Title/Title");
const FormData_1 = require("../../context/FormData");
const Progress_1 = require("../../context/Progress");
const mediaQueries_1 = require("../../styles/mediaQueries");
/**
 * The number of specialities to show when the list is collapsed by default
 */
const COUNT_TO_SHOW = 5;
function SpecialityListWithTitle({ title, specialities, countToShow = COUNT_TO_SHOW, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [{ nextRoute }] = (0, Progress_1.useProgress)();
    const [formDataState, dispatchFormData] = (0, FormData_1.useFormData)();
    const [hasNavigated, setHasNavigated] = react_1.default.useState(false);
    const [isExpanded, setIsExpanded] = react_1.default.useState(false);
    const [isShowMoreButtonHidden, setIsShowMoreButtonHidden] = react_1.default.useState(false);
    const specialitiesToShow = isExpanded
        ? specialities
        : specialities.slice(0, countToShow);
    const displayShowMoreButton = !isExpanded && specialities.length > countToShow;
    const onShowMoreClick = () => {
        setIsShowMoreButtonHidden(true);
    };
    const navigateToNextPage = () => {
        if (!nextRoute || hasNavigated) {
            return;
        }
        setHasNavigated(true);
        navigate(`../../${nextRoute}`, { state: { canGoBack: true } });
    };
    const createOnSpecialitySelect = (speciality) => () => {
        /**
         * User clicks on the same speciality button
         * Navigate to the next page without button animation
         * Don't dispatch the action to avoid unnecessary re-renders
         */
        if (formDataState.speciality === speciality) {
            navigateToNextPage();
            return;
        }
        dispatchFormData((0, FormData_1.setSpeciality)(speciality));
    };
    const specialitiesButtons = specialitiesToShow.map(speciality => ((0, jsx_runtime_1.jsx)(SelectableButton_1.SelectableButton, { selected: formDataState.speciality === speciality, onClick: createOnSpecialitySelect(speciality), onAnimationEnd: isAppearing => {
            if (!isAppearing && formDataState.speciality === speciality) {
                navigateToNextPage();
            }
        }, "data-e2e": 'SpecialityListWithTitle_SelectableButton', children: t(i18n_1.Strings.userOnboarding.specialities[speciality]) }, speciality)));
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TitleContainer, { "data-e2e": 'SpecialityListWithTitle_TitleContainer', children: (0, jsx_runtime_1.jsx)(StyledTitle, { "data-e2e": 'SpecialityListWithTitle_StyledTitle', children: title }) }), (0, jsx_runtime_1.jsx)(ButtonsContainer, { "data-e2e": 'SpecialityListWithTitle_ButtonsContainer', children: (0, jsx_runtime_1.jsxs)(ButtonsGridView, { "data-e2e": 'SpecialityListWithTitle_ButtonsGridView', children: [specialitiesButtons, displayShowMoreButton && ((0, jsx_runtime_1.jsx)(FlatButton_1.FlatButton, { willUnmount: isShowMoreButtonHidden, onClick: onShowMoreClick, onUnmountAnimationEnd: () => setIsExpanded(true), "data-e2e": 'SpecialityListWithTitle_FlatButton', children: t(i18n_1.Strings.userOnboarding.common.showMore) }))] }) })] }));
}
exports.SpecialityListWithTitle = SpecialityListWithTitle;
const TitleContainer = styled_components_1.default.div `
  margin-bottom: 28px;

  ${mediaQueries_1.device.desktop `
    display: flex;
    align-items: flex-end;
    flex-shrink: 0;
    
    height: 164px;
    margin-bottom: 24px;
  `}
`;
const StyledTitle = (0, styled_components_1.default)(Title_1.Title) `
  ${mediaQueries_1.device.desktop `
    text-align: left;
  `}
`;
const ButtonsGridView = styled_components_1.default.div `
  /* If one of buttons has two or more lines of text, each button should have the same height */
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: 1fr;
  row-gap: 16px;
`;
const ButtonsContainer = styled_components_1.default.div `
  width: 100%;

  box-sizing: border-box;
  padding: 16px 8px 16px 16px;

  overflow-y: auto;

  ${mediaQueries_1.device.mobileLandscape `
    width: max-content;

    & button {
      width: 280px;
    }
  `}

  ${mediaQueries_1.device.desktop `
    width: 100%;

    padding: 16px 8px 16px 16px;
    margin: 0 -16px -16px;

    & button {
      width: 100%;
    }
  `}
`;
